import React from 'react';

const ManageServicesLocationBar = ({
  locations = [],
  selectedLocationId = '',
  onSelectLocation,
}) => {
  if (locations.length <= 1) {
    return null;
  }

  return (
    <div className="ms2-locationBar" role="region" aria-label="Select location">
      <div className="ms2-locationBar__intro">
        <span className="ms2-locationBar__label">Location</span>
        <p className="ms2-locationBar__hint">
          Choose a location to manage which services are offered there.
        </p>
      </div>
      <div className="ms2-locationBar__tabs" role="tablist" aria-label="Business locations">
        {locations.map((location) => {
          const selected = selectedLocationId === location.id;
          return (
            <button
              key={location.id}
              type="button"
              role="tab"
              aria-selected={selected}
              className={`ms2-locationBar__tab${selected ? ' is-selected' : ''}`}
              onClick={() => onSelectLocation?.(location.id)}
            >
              {location.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ManageServicesLocationBar;
